export const DEFAULT_RADIUS_IN_KM = 0.5;

export const SHAPE_FILL_OPACITY = 0.4;

/** Single-ring radius (meters) for auto-created attribution zones. */
export const ATTRIBUTION_RADIUS_IN_METERS = 50;
